import React, { useState } from 'react';
import { CardBody } from 'reactstrap';
import DefaultModal from 'components/Modal/DefaultModal';
import ProductsByPriceCatalogTable from '../ProductsByPriceCatalogTable';

const ProductsByPriceCatalogModal = ({
  isModalOpen,
  onModalToggle,
  catalogId,
  ...props
}) => {
  const [loading, setLoading] = useState(true);
  return (
    <>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={onModalToggle}
        title="Produtos no catálogo de preços"
        showCloseButton={false}
        modalContainerClasses="modal-xl"
        {...props}
      >
        <CardBody>
          <ProductsByPriceCatalogTable
            catalogId={catalogId}
            loadingTable={loading}
            onTableLoaded={setLoading}
          />
        </CardBody>
      </DefaultModal>
    </>
  );
};

export default ProductsByPriceCatalogModal;
